/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Alert_ErrorInputs */

const en_form_alert_error = /** @type {(inputs: Form_Alert_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again later.`)
};

const ar_form_alert_error = /** @type {(inputs: Form_Alert_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث خطأ ما. يرجى المحاولة لاحقًا.`)
};

const bn_form_alert_error = /** @type {(inputs: Form_Alert_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কিছু একটা ভুল হয়েছে। পরে আবার চেষ্টা করুন।`)
};

const de_form_alert_error = /** @type {(inputs: Form_Alert_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal.`)
};

const es_form_alert_error = /** @type {(inputs: Form_Alert_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal. Inténtelo de nuevo más tarde.`)
};

const fr_form_alert_error = /** @type {(inputs: Form_Alert_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelque chose s'est mal passé. Veuillez réessayer plus tard.`)
};

const pt_form_alert_error = /** @type {(inputs: Form_Alert_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado. Por favor, tente novamente mais tarde.`)
};

const zh_form_alert_error = /** @type {(inputs: Form_Alert_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出了点问题。请稍后重试。`)
};

const tr_form_alert_error = /** @type {(inputs: Form_Alert_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir şeyler ters gitti. Lütfen daha sonra tekrar deneyin.`)
};

const ru_form_alert_error = /** @type {(inputs: Form_Alert_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что-то пошло не так. Пожалуйста, повторите попытку позже.`)
};

const pl_form_alert_error = /** @type {(inputs: Form_Alert_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coś poszło nie tak. Spróbuj ponownie później.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please try again later." |
*
* @param {Form_Alert_ErrorInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_alert_error = /** @type {((inputs?: Form_Alert_ErrorInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Alert_ErrorInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_alert_error(inputs)
	if (locale === "bn") return bn_form_alert_error(inputs)
	if (locale === "de") return de_form_alert_error(inputs)
	if (locale === "es") return es_form_alert_error(inputs)
	if (locale === "fr") return fr_form_alert_error(inputs)
	if (locale === "pt") return pt_form_alert_error(inputs)
	if (locale === "zh") return zh_form_alert_error(inputs)
	if (locale === "tr") return tr_form_alert_error(inputs)
	if (locale === "ru") return ru_form_alert_error(inputs)
	if (locale === "pl") return pl_form_alert_error(inputs)
	return en_form_alert_error(inputs)
});